import img1 from '../../assets/WhyVedaImg3.png';
import img2 from '../../assets/WhyVedaImg2.png';
import img3 from '../../assets/WhyVedaImg1.png';
import img4 from '../../assets/WhyVedaImg4.png';

const features = [
  { img: img1, title: "ROOT CAUSE APPROACH", desc: "We treat the source, not just the symptom." },
  { img: img2, title: "AUTHENTIC AYURVEDA", desc: "Time-tested formulations, purely sourced." },
  { img: img3, title: "MODERN DIAGNOSTICS", desc: "Ancient wisdom backed by modern science." },
  { img: img4, title: "PERSONALIZED CARE", desc: "A wellness plan built around you." },
];

export default function FeaturesSlider() {
  return (
    <section className="py-20 bg-[#faf6ee]">
      <div className="text-center mb-14">
        {/* <p className="uppercase md:text-xl text-base font-extrabold text-brand-gold">Why VedaNova?</p> */}
        <h2 className="text-4xl sm:text-5xl font-bold text-brand-gold mt-4">A New Era Of Modern Ayurveda</h2>
      </div>

      <div className="max-w-6xl mx-auto md:px-4 px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item, index) => (
            <div
              key={index}
              className="group relative h-80  rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              {/* Background image */}
              <img
                src={item.img}
                alt={item.title}
                className="absolute inset-0 object-cover md:p-6 p-16  transition-transform duration-700 group-hover:scale-110"
              />

              {/* Gradient overlay - darker on hover for readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:from-black/90 transition-all duration-500" />

              {/* Top accent line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* Shine sweep */}
              <div className="absolute -left-full top-0 h-full w-1/2 bg-white/10 skew-x-12 group-hover:left-[150%] transition-all duration-1000 pointer-events-none" />

              {/* Text content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-6 group-hover:translate-y-0 transition-transform duration-500">
                <div className="w-8 h-[2px] bg-yellow-400 mb-3 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                <h3 className="text-lg font-bold text-brand-gold tracking-wide">{item.title}</h3>
                <p className="text-sm text-gray-200 mt-2 opacity-0 group-hover:opacity-100 max-h-0 group-hover:max-h-20 overflow-hidden transition-all duration-500">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}